<template>
  <div v-loading="isBusy">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      element-loading-spinner="el-icon-loading"
      label-width="170px"
    >
      <el-form-item label="First Name" prop="first_name" v-if="canEdit('first_name')">
        <el-input v-model="form.first_name"></el-input>
      </el-form-item>
      <el-form-item label="Last Name" prop="last_name" v-if="canEdit('last_name')">
        <el-input v-model="form.last_name"></el-input>
      </el-form-item>
      <el-form-item prop="status" label="Status" :required="true" v-if="canEdit('status')">
        <el-select v-model="form.status" class="w-100">
          <el-option
            v-for="{label, value} in statusOptions"
            :key="value"
            :label="label"
            :value="value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="Phone number"
        prop="phone_number"
        v-if="isPhoneNumberEditable"
      >
        <el-input v-model="form.phone_number"></el-input>
      </el-form-item>
      <el-form-item label="Email" prop="email" v-if="canEdit('email')">
        <el-input v-model="form.email"></el-input>
      </el-form-item>
      <el-form-item label="Email context" prop="email_context" v-if="canEdit('email_context')">
        <el-input v-model="form.email_context"></el-input>
      </el-form-item>
      <el-form-item label="Filemaker ID" prop="filemaker_id" :required="true" v-if="canEdit('filemaker_id')">
        <el-input v-model="form.filemaker_id"></el-input>
      </el-form-item>
    </el-form>
    <button class="btn btn-purple px-4" @click="store">Store</button>
  </div>
</template>

<script>
import BaseForm from '../form';

export default {
  extends: BaseForm,

  props: {
    statusOptions: Array,
    editableFields: Object,
  },

  data() {
    const form = {
      first_name: null,
      last_name: null,
      phone_number: null,
      filemaker_id: null,
      status: null,
      email: null,
      email_context: null,
    };

    return {
      form,
      rules: _.mapValues(form, () => [{validator: this.fieldExternalValidator}]),
    }
  },

  computed: {
    /**
     * @return {boolean}
     */
    isPhoneNumberEditable() {
      return this.canEdit('phone_number') || !this.isEditMode;
    }
  },

  methods: {
    /**
     * @param {Object} model
     */
    initForm(model) {
      this.form = _.mapValues(this.form, (val, prop) => _.get(model, prop, null));
    },

    /**
     * @return {Object}
     */
    getForm() {
      const omit = this.isPhoneNumberEditable ? [] : ['phone_number'];

      return _.omit({...this.form, _method: this.method}, omit);
    },

    /**
     * @param field
     */
    canEdit(field) {
      if (_.isEmpty(this.editableFields)) {
        return true;
      }

      return _.get(this.editableFields, field);
    },
  },
}
</script>
